import React, { ReactNode } from "react"
import { Box, BoxProps, Paper, PaperProps } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: theme.spacing(1), 
        marginBottom: theme.spacing(1)
    },
}));

interface ContainerProps {
    children: ReactNode,
    paperProps? : PaperProps,
    boxProps?: BoxProps
}

/**
 * This is a re-usable Container Component. The style of container can be changed by importing props
 */
const Container : React.FunctionComponent<ContainerProps> = (props) => {  
    const styles = useStyles();
    return (
        <div className={styles.root}>
            <Paper  {...props.paperProps} >
                <Box {...props.boxProps}>{props.children}</Box>
            </Paper>
        </div>  
    );
}

export default Container;

